import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Creators } from './duck/actions';

// All the imports from common
import Banner from '../common/Banner/Banner';
import AdBanner from '../common/AdBanner/AdBanner';
import OuterBox from '../common/OuterBox/OuterBox';
import InnerBox from '../common/InnerBox/InnerBox';
import Latest from '../common/Latest/Latest';
import BannerLoader from '../common/Loaders/BannerLoader';
import { ListElement, Image } from '../common/StyledComponents';
import { SideBar } from '../common/StyledComponents/StyledSideBar';

// All the imports related to Ads
import adLinkedin from '../../assets/images/ad-linkedin.png';
import adAmazon from '../../assets/images/ad-amazon.png';
import adAmazonVertical from '../../assets/images/ad-amazon-vertical.png';
import adTissot from '../../assets/images/ad-tissot.png';
import adSuggested from '../../assets/images/ad-suggested.png';
import adSuggestedVertical from '../../assets/images/ad-suggested-vertical.png';

class T3 extends Component {
  componentWillMount = () => {
    // console.log('[T3.js] componentWillMount');
    window.scrollTo(0, 0);
  };

  componentDidMount = () => {
    // console.log('[T3.js] - CDM');
    // console.log('[News.js] componentDidMount');
    this.props.onFetchT3Banner();
    this.props.onFetchLatestT3(1);
  };

  componentDidUpdate = (prevProps, prevState) => {
    // console.log('[T3.js] - CDUp');
    // Make API requests according to the page that needs to be fetched.
  };

  handleLoadMore = () => {
    this.props.onFetchLatestT3(this.props.pageForLatestT3);
  };

  navigate = postSlug => {
    // console.log('postSlug: ', postSlug);
    this.props.history.push(`/${postSlug}`);
  };

  render() {
    // console.log('this.props: ', this.props);
    const { t3BannerData, latestT3 } = this.props;
    return (
      <div className="T3">
        <AdBanner height="250px" width="970px" margin="1rem 0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        {t3BannerData ? (
          <Banner bannerData={t3BannerData} clicked={this.navigate} />
        ) : (
          <BannerLoader />
        )}

        <OuterBox>
          <InnerBox>
            <Latest
              title="Latest Tips Tricks and Tutorials"
              titleProps={{
                fontFamily: 'Montserrat',
                fontSize: '2.25rem',
                fontWeight: 'bold'
              }}
              contentData={latestT3}
              handleLoadMore={this.handleLoadMore}
              clicked={this.navigate}
            />

            <SideBar>
              <AdBanner height="250px" width="300px" margin="0 0 18px 0">
                <Image
                  src={adAmazon}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              <AdBanner height="565px" width="300px" margin="0">
                <Image
                  src={adSuggestedVertical}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>

              <AdBanner height="600px" width="300px" margin="18px 0 18px 0">
                <Image
                  src={adAmazonVertical}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
              <AdBanner height="250px" width="300px" margin="0 0 18px 0">
                <Image
                  src={adLinkedin}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </SideBar>
          </InnerBox>
        </OuterBox>

        <AdBanner height="250px" width="970px" margin="0">
          <Image src={adTissot} width="100%" height="100%" alt="tissot ad" />
        </AdBanner>

        <OuterBox>
          <InnerBox>
            <ListElement className="w-100" maxwidth="100%" padding="20px">
              <AdBanner height="346px" width="1040px" margin="0">
                <Image
                  src={adSuggested}
                  width="100%"
                  height="100%"
                  alt="tissot ad"
                />
              </AdBanner>
            </ListElement>
          </InnerBox>
        </OuterBox>
      </div>
    );
  }
}

const mapStateToProps = state => {
  // console.log('state: ', state);
  return {
    loading: state.t3.loading,
    t3BannerData: state.t3.t3BannerData,
    latestT3: state.t3.latestT3,
    pageForLatestT3: state.t3.pageForLatestT3
  };
};

const mapDispatchToProps = dispatch => ({
  onFetchT3Banner: () => dispatch(Creators.fetchT3Banner()),
  onFetchLatestT3: page => dispatch(Creators.fetchLatestT3(page))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(T3);
